import { useTranslation } from 'react-i18next';
import type { DamageTypeWithLineItems } from '@/common/damage';
import type { SubAsset } from '@/common/sub-asset';
import { unitTypeLabel } from '@/common/work-package';
import { TableCell, TableRow } from '@/components/ui/table';

type SubAssetWithDamages = SubAsset & {
	damages?: DamageTypeWithLineItems[];
};
export type DamageLineItemsProps = {
	subAssetWithDamages?: SubAssetWithDamages;
};
export function DamageLineItems({ subAssetWithDamages }: DamageLineItemsProps) {
	const { t } = useTranslation();
	const damages = subAssetWithDamages?.damages || [];
	if (!damages?.length && !subAssetWithDamages?.children?.length) {
		return null;
	}
	return (
		<>
			{!!damages?.length && subAssetWithDamages?.name && (
				<TableRow key={subAssetWithDamages.name} className="border-b bg-background/40 hover:bg-background">
					<TableCell className="font-semibold py-3" colSpan={8}>
						{subAssetWithDamages.name}
					</TableCell>
				</TableRow>
			)}
			{damages?.map((item) => (
				<TableRow key={item.id} className="border-b transition-colors data-[state=selected]:bg-muted">
					<TableCell className=" text-muted-foreground font-mono text-sm">{item.id}</TableCell>
					<TableCell>{item.title}</TableCell>
					<TableCell className=" text-muted-foreground">{item.status}</TableCell>
					<TableCell className=" text-muted-foreground">{item.class}</TableCell>
					<TableCell className=" text-muted-foreground">{item.material}</TableCell>
					<TableCell className=" text-muted-foreground">{item.type}</TableCell>
					<TableCell className=" text-muted-foreground">{item.lineItem?.quantity}</TableCell>
					<TableCell className=" text-muted-foreground">{unitTypeLabel(t, item.lineItem?.unitType)}</TableCell>
				</TableRow>
			))}
			{subAssetWithDamages?.children?.map((childSubAsset) => (
				<DamageLineItems key={childSubAsset.id} subAssetWithDamages={childSubAsset} />
			))}
		</>
	);
}
